<section class="my-ticket-mobile-wrap">
    <ng-container *ngIf="isUsserLogged; else notLogged">
        <div class="ticket-option-wrap">
            <div class="ticket-option" [class.selected]="ticketsFilterStatus == ticketFilterStatusEnum.All" (click)="changeTicketsFilter(ticketFilterStatusEnum.All)">
                <ng-container i18n="My Tickets filter@@myTicketsTabFilterAll">Svi</ng-container>
            </div>
            <div class="ticket-option" [class.selected]="ticketsFilterStatus == ticketFilterStatusEnum.Active" (click)="changeTicketsFilter(ticketFilterStatusEnum.Active)">
                <ng-container i18n="My Tickets filter@@myTicketsTabFilterActive">Aktivni</ng-container>
            </div>
            <div class="ticket-option" [class.selected]="ticketsFilterStatus == ticketFilterStatusEnum.Win" (click)="changeTicketsFilter(ticketFilterStatusEnum.Win)">
                <ng-container i18n="My Tickets filter@@myTicketsTabFilterWon">Dobitni</ng-container>
            </div>
            <div class="ticket-option" [class.selected]="ticketsFilterStatus == ticketFilterStatusEnum.Lost" (click)="changeTicketsFilter(ticketFilterStatusEnum.Lost)">
                <ng-container i18n="My Tickets filter@@myTicketsTabFilterLost">Gubitni</ng-container>
            </div>

        </div>

        <div class="my-tickets-wrap" id="myTicketsWrap">
            <!-- <div class="loader-wrap loading absolute" *ngIf="loading"><div class="spinner"></div></div> -->
            <div class="my-ticket" *ngFor="let ticket of myTickets">
                <div class="ticket-content" (click)="expandTicketDetail(ticket.id)">

                    <div class="ticket-item">
                        <span class="bold">{{ticket.createdOn | date:'dd.MM.'}} {{ticket.createdOnTime}}</span>
                        <span class="title" *ngIf="ticket.isFreeBet; else notFreebet">Free bet</span>
                        <ng-template #notFreebet>
                            <span class="title" *ngIf="ticket.numberOfCombinations > 1" i18n="ticket System tab title@@ticketTabSystem">Sistem</span>
                            <span class="title" *ngIf="ticket.numberOfCombinations == 1" i18n="normal ticket@@normalTicket">Obican</span>
                        </ng-template>
                        <span class="bold a-r"><span i18n="My Tickets played ticket number of events@@myTicketsTabEvents">parovi</span>: {{ticket.numberOfMatches}}</span>
                    </div>
                    <div class="ticket-item">
                      <ng-container *ngIf="ticket.id == expandedTicketId; else eventNames">
                        <span class="ticket-status type2 {{ticketStatusEnum[ticket.status.code] | lowercase}}" [class.cash]="ticket.cashoutValue && !ticket.blockedForSell">
                            {{dynamicTranslations['ticketAndOtherStatuses_'+[ticketStatusEnum[ticket.status.code]]] ? dynamicTranslations['ticketAndOtherStatuses_' + [ticketStatusEnum[ticket.status.code]]] : ticket.status.name }}
                        </span>
                        <span class="center">{{ticket.ticketNumber}}</span>
                      </ng-container>
                      <ng-template #eventNames>
                        <span class="event-names-preview">
                            <ng-container *ngFor="let event of ticket?.events; let i=index">
                                <i class="icon-ex-sm s-icon-{{getSportName(event.sportId)}} sportid-{{event.sportId}}"></i>
                                {{event.name}}
                                <ng-container *ngIf="i < ticket?.events.length - 1">, </ng-container>

                            </ng-container>

                        </span>
                      </ng-template>

                      <i class="arrow-down icon icon-xs icon-chevron-up" [class.closed]="ticket.id != expandedTicketId"></i>
                    </div>

                    <div class="line"></div>

                    <div class="ticket-item" *ngIf="ticket.id != expandedTicketId" >
                        <div class="ticket-status payin">
                            <span><span i18n="Ticket Pay in text@@TicketPayIn">Uplata</span>:</span>
                            <span> {{ticket.payin | number:'1.2-2'}} {{currency}}</span>
                        </div>

                        <div class="ticket-status {{ticketStatusEnum[ticket.status.code] | lowercase}}">
                            <span><span i18n="Ticket Pay out text@@TicketPayOut">Isplata</span>:</span>
                            <span> {{ticket.possiblePayout | number:'1.2-2'}} {{currency}}</span>
                        </div>
                    </div>


                </div>
                <app-my-ticket-details *ngIf="ticket.id == expandedTicketId"  [ticketId]="ticket.id"></app-my-ticket-details>
            </div>

            <div class="no-result" *ngIf="myTickets && myTickets.length === 0">
                <span i18n="there are no tickets for the selected filter@@TicketDoesNotExist">Nema listića u ovoj kategoriji</span>
            </div>
        </div>
    </ng-container>

    <ng-template #notLogged>
        <div class="no-result">
            <span i18n="My Tickets not logged in@@MyTicketsPlsLogin">Molimo vas da se ulogujete <br />kako biste imali pristup listi odigranih tiketa.</span>
        </div>
    </ng-template>
</section>
